import { Link } from "react-router-dom";


export default function FooterOnline() {


   return (
      <>
         <footer className="footer mt-5 p-2 text-white text-center bgBlack">
            <div className="container-fluid p-4 ">
               <h5 className="header-title-text m-0 d-flex justify-content-center flex-column gap-1">
                  <span className="text-white">SMART</span>
                  <span className="ps-1 ">TREND</span>
               </h5>
               <div className="row">
                  <div className="col-md-12">
                     <p className="footer-info fs-sm">
                        منصة إلكترونية مجانية تقدم   خدمات  الرعاية الصحية (الخدمات  الطبية والأشعة التشخيصية)
                     </p>
                  </div>

                  <div className="row my-2">
                     <div className="col-md-4 offset-md-2 text-start ">
                        <div ><i className="fa-solid fa-envelope mx-3"></i>info@sm-trend.com</div>
                     </div>

                     <div className="col-md-4 offset-md-2  text-start ">
                        <div className="my-2"><Link to="https://wa.me/201066991090" ><i class="fa-solid fa-phone-volume mx-3"></i> 01066991090</Link></div>
                     </div >
                  </div>

                  <div className=" d-flex justify-content-center align-items-center parentIcon">
                     <Link className="cartIconFooter" to="https://www.facebook.com/share/1BmHc3BN6e/">
                        <i className="fa-brands  fa-facebook text-white"></i>
                     </Link>

                     <Link className="cartIconFooter">
                        <i className="fa-brands  fa-telegram text-white"></i>
                     </Link>
                     <Link className="cartIconFooter" to="https://www.instagram.com/smarttrendcompany/profilecard/?igsh=dnE1aWN4Y3FxdWs3">
                        <i className="fa-brands  fa-instagram text-white"></i>
                     </Link>
                     <Link className="cartIconFooter" to="https://wa.me/201066991090" >
                        <i className="fa-brands fa-whatsapp text-white"></i>
                     </Link>
                  </div>

               </div>
            </div>
            <p className="m-0 bgBlack developer">CopyRight &copy; Developed By : <Link className="bgBlack" to={"#"}>M-E Group</Link></p>
         </footer>
      </>
   )
}